import { Separator } from '@heroui/react';
import classNames from 'classnames';
import type { TFuncKey } from 'i18next';

import DynamicT from '@/shared/components/DynamicT';

type Props = {
  readonly className?: string;
  readonly label?: TFuncKey;
};

const Divider = ({ className, label }: Props) => {
  if (!label) {
    return <Separator className={className} />;
  }

  return (
    <div className={classNames('flex items-center gap-3', className)}>
      <Separator variant="secondary" className="flex-1" />
      <span className="shrink-0 text-xs text-muted">
        <DynamicT forKey={label} />
      </span>
      <Separator variant="secondary" className="flex-1" />
    </div>
  );
};

export default Divider;
